function getConfig(name, defaultValue = null) {
  // If inside a docker container, use window.ENV
  if (window.ENV !== undefined) {
    return window.ENV[name] || defaultValue;
  }

  return import.meta.env[name] || defaultValue;
}

export function getBackendUrl() {
  return getConfig("VITE_BACKEND_URL");
}

export function getHoursCloseTicketsAuto() {
  return getConfig("VITE_HOURS_CLOSE_TICKETS_AUTO");
}

export function getFrontendVersion() {
  const fallbackVersion =
    typeof __APP_VERSION__ !== "undefined" ? __APP_VERSION__ : "unknown";
  return getConfig("VITE_APP_VERSION", fallbackVersion);
}

export function getFrontendEnvironment() {
  return getConfig("VITE_APP_ENV", import.meta.env.MODE || "development");
}

export function getFrontendGitSha() {
  return getConfig("VITE_APP_GIT_SHA", "unknown");
}

export function getFrontendGitRef() {
  return getConfig("VITE_APP_GIT_REF", "unknown");
}

export function getFrontendBuildTimestamp() {
  return getConfig("VITE_APP_BUILD_TIMESTAMP", "unknown");
}
